<div class="import-info">
  <i class="pi pi-info-circle"></i>
  <div class="import-info-text">
    <b>Datei-Import – wichtige Hinweise</b>

    <ul>
      <li>
        <b>Pflichtfelder:</b><br />
        Die Felder <b>Kategorie</b>, <b>Kurs</b> und <b>Teilnehmer</b> müssen in
        jeder Zeile ausgefüllt sein. Zeilen mit fehlenden Pflichtangaben werden
        nicht importiert.
      </li>
      <li>
        <b>Kategorieabhängige Angaben:</b><br />
        Die Art der Kategorie entscheidet, welche Spalten ausgewertet werden:
        <ul>
          <li>
            <b>Technik (z. B. Laptop, Monitor, Smartphone):</b><br />
            <b>Modell</b> und <b>Seriennummer</b> sind zwingend erforderlich.
            CPU, Hersteller, RAM, Speicher, Betriebssystem, Asset-Tag und die
            Zugangsdaten sind optional. Die Spalte <b>Buch Versand</b> wird
            ignoriert.
          </li>
          <li>
            <b>Buch:</b><br />
            <b>Modell</b> enthält den Buchtitel, eine <b>Seriennummer</b> wird
            nicht benötigt. Ausgewertet wird zusätzlich <b>Buch Versand</b> mit
            den Werten <b>Versendet</b> oder <b>Nicht versendet</b>. Technische
            Angaben und Zugangsdaten werden ignoriert.
          </li>
        </ul>
      </li>

      <li>
        <b>Start- und Enddatum:</b><br />
        Diese Felder sind optional. Wenn kein Datum angegeben wird, wird
        automatisch der Zeitraum des zugeordneten Kurses verwendet.
      </li>

      <li>
        <b>Status und Rückgabestatus:</b><br />
        Bitte ausschließlich über die vorgesehenen
        <b>Dropdown-Felder</b> auswählen, um ungültige Werte zu vermeiden.
      </li>

      <li>
        <b>Beispielzeile:</b><br />
        Die Beispielzeile in der Vorlage dient nur zur Orientierung und wird
        beim Import automatisch ignoriert.
      </li>
    </ul>

    <div class="import-info-hint">
      👉 <b>Empfehlung:</b> Beginne immer mit <b>„Vorlage herunterladen“</b>, um
      ein korrektes Format sicherzustellen und Importfehler zu vermeiden.
    </div>
  </div>
</div>

<div class="import-main">
  <div
    class="dropzone"
    [class.dragover]="isDragOver"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
  >
    <div class="dropzone-inner">
      <i class="pi pi-cloud-upload dropzone-icon"></i>

      <div class="dropzone-text">
        <div class="dropzone-title">Datei hier ablegen</div>
        <div class="dropzone-subtitle">oder Datei auswählen</div>
      </div>

      <button
        pButton
        type="button"
        icon="pi pi-folder-open"
        label="Datei auswählen"
        class="p-button-outlined"
        (click)="triggerBrowse()"
      ></button>
    </div>

    <div class="dropzone-hint">
      Unterstützt: <b>.xlsx</b>, <b>.xls</b>
      @if (fileName) {
        <span class="dropzone-filename">— {{ fileName }}</span>
      }
    </div>

    <input
      #fileInput
      type="file"
      accept=".xlsx,.xls"
      (change)="onFileSelected($event)"
      hidden
    />
  </div>

  @if (validationErrors.length) {
    <div class="import-errors">
      <div class="import-errors-header">
        <i class="pi pi-exclamation-triangle"></i>
        <b>{{ validationErrors.length }} Fehler in der Datei</b>
        <span class="import-errors-hint"
          >Der Import ist gesperrt, bis alle Fehler behoben sind.</span
        >
      </div>

      <ul>
        @for (err of validationErrors; track $index) {
          <li>{{ err }}</li>
        }
      </ul>
    </div>
  } @else if (payload.length) {
    <div class="import-ready">
      <i class="pi pi-check-circle"></i>
      {{ payload.length }}
      {{ payload.length === 1 ? "Datensatz" : "Datensätze" }} bereit zum Import.
    </div>
  }

  <div class="import-actions">
    <button
      pButton
      type="button"
      icon="pi pi-download"
      label="Vorlage herunterladen"
      [loading]="loadingTemplate"
      (click)="downloadTemplate()"
    ></button>

    <button
      pButton
      type="button"
      icon="pi pi-upload"
      label="Importieren"
      class="p-button-success"
      [loading]="importing || processingFile"
      [disabled]="!canClickImport"
      (click)="import()"
    ></button>
  </div>
</div>
